import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-10 md:py-14 px-4 bg-black text-white text-center" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-130">
            Si quieres bajar de peso, déjame hacerte una pregunta honesta
          </h2>

          <div className="space-y-3 text-xl md:text-2xl font-medium text-gray-300 mb-8" data-id="element-131">
            <p data-id="element-132">¿Te pasa que empiezas una dieta con motivación…</p>
            <p data-id="element-133">y a la semana ya estás cansado de seguirla?</p>
          </div>

          <div className="space-y-2 text-lg md:text-xl text-gray-400 mb-8" data-id="element-134">
            <p data-id="element-135">No porque no tengas fuerza de voluntad.</p>
            <p data-id="element-136">No porque no quieras mejorar tu salud.</p>
            <p className="text-white font-bold text-xl md:text-2xl mt-4" data-id="element-137">
              <span className="bg-red-600 px-2 py-1 rounded" data-id="element-138">
                Sino porque la mayoría de las dietas son difíciles de mantener.
              </span>
            </p>
          </div>

          <div className="bg-gray-900 p-6 rounded-2xl border border-gray-800 shadow-2xl mb-8" data-id="element-139">
            <p className="text-lg md:text-xl mb-3 text-gray-300" data-id="element-140">
              Comidas complicadas. Recetas que llevan demasiado tiempo.
              Ingredientes caros o difíciles de conseguir.
            </p>
            <p className="text-2xl font-bold text-red-500" data-id="element-141">
              Y al final terminas volviendo a lo mismo.
            </p>
          </div>

          <div className="mt-10" data-id="element-142">
            <h3 className="text-2xl md:text-4xl font-bold mb-4 text-yellow-400" data-id="element-143">
              El problema que nadie dice en voz alta
            </h3>

            <p className="text-xl mb-4" data-id="element-144">
              La mayoría de las dietas fracasan por tres razones:
            </p>

            <div className="flex flex-col items-center space-y-2 text-xl font-bold mb-6" data-id="element-145">
              <span className="flex items-center" data-id="element-146">
                <span className="text-red-500 mr-3" data-id="element-147">❌</span> son demasiado
                restrictivas
              </span>
              <span className="flex items-center" data-id="element-148">
                <span className="text-red-500 mr-3" data-id="element-149">❌</span> requieren
                demasiado tiempo
              </span>
              <span className="flex items-center" data-id="element-150">
                <span className="text-red-500 mr-3" data-id="element-151">❌</span> la comida es
                aburrida
              </span>
            </div>

            <p className="text-xl mb-3" data-id="element-152">Por eso muchas personas:</p>

            <div className="flex flex-col items-center space-y-1 text-lg text-gray-300 mb-6" data-id="element-153">
              <p data-id="element-154">abandonan a la semana</p>
              <p data-id="element-155">vuelven a subir de peso</p>
              <p data-id="element-156">terminan frustradas</p>
            </div>

            <div className="bg-red-900/30 p-6 rounded-xl border border-red-800/50" data-id="element-157">
              <p className="text-xl md:text-2xl font-bold mb-2" data-id="element-158">
                Y el problema no es tu falta de disciplina.
              </p>
              <p className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-159">
                El problema es que nadie te enseñó cómo comer rico y adelgazar
                al mismo tiempo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}